import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform, Modal } from 'react-native';
import { MaterialIcons, MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../styles/variablesCss';
import SelecSuc from '../Home/Header/SelecSuc';

const Retiro = () => {
  const [sucursalInfo, setSucursalInfo] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  // Función para cargar datos de sucursal desde localStorage
  const cargarSucursalDesdeStorage = () => {
    if (Platform.OS === 'web') {
      try {
        const ciudad = localStorage.getItem('ciudadNom') || 'RAFAELA';
        const selectedSubBranch = localStorage.getItem('selectedSubBranch') || 'Av. Roque Sáenz Peña 321';
        const telefono = localStorage.getItem('sucursalDeRetiro') || 'Tel: (03492) 506104 - 504000';
        const sucursalId = localStorage.getItem('sucursalId') || "falta"; // Valor predeterminado

        if (ciudad) {
          setSucursalInfo({
            sucursalId,
            ciudad,
            selectedSubBranch,
            telefono
          });
        }
      } catch (error) {
        console.error('Error al cargar sucursal:', error);
      }
    }
  };

  // Cargar datos de sucursales desde localStorage al montar y escuchar cambios
  useEffect(() => {
    // Carga inicial
    cargarSucursalDesdeStorage();

    // Listener para detectar cambios en localStorage (solo web)
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const handleStorageChange = (e) => {
        // Detectar cambios en cualquiera de las claves relacionadas con sucursal
        if (e.key === 'ciudadNom' || e.key === 'sucursalId' || e.key === 'selectedSubBranch') {
          cargarSucursalDesdeStorage();
        }
      };

      // Listener para cambios personalizados en la misma pestaña
      const handleCustomStorageChange = (e) => {
        if (e.detail?.key === 'ciudadNom' || e.detail?.key === 'sucursalId' || e.detail?.key === 'selectedSubBranch') {
          cargarSucursalDesdeStorage();
        }
      };

      window.addEventListener('storage', handleStorageChange);
      window.addEventListener('localStorageChange', handleCustomStorageChange);

      return () => {
        window.removeEventListener('storage', handleStorageChange);
        window.removeEventListener('localStorageChange', handleCustomStorageChange);
      };
    }
  }, []);


  // Función para guardar datos de sucursal en localStorage (solo en web)
  const guardarSucursalEnStorage = (datos) => {
    if (Platform.OS !== 'web') return;

    const {
      ciudad,
      selectedSubBranch,
      telefono,
      sucursalId
    } = datos;

    // Guardar todos los datos relevantes
    localStorage.setItem('ciudadNom', ciudad);
    localStorage.setItem('selectedSubBranch', selectedSubBranch);
    localStorage.setItem('sucursalDeRetiro', telefono);
    localStorage.setItem('sucursalId', sucursalId);
  };

  // Función para manejar la selección de sucursal desde el modal
  const handleSucursalSelect = (ciudad, selectedSubBranch, numero) => {
    // SelecSuc.js ya guarda todo en localStorage, solo necesitamos recargar
    // Esperamos un momento para que los datos se guarden completamente
    setTimeout(() => {
      cargarSucursalDesdeStorage();
    }, 100);
  };



  return (
    <View style={styles.container}>

      {sucursalInfo && (
        <View style={styles.sucursalSeleccionadaContainer}>
          <View style={styles.sucursalIconContainer}>
            <MaterialCommunityIcons
              name="map-marker"
              size={24}
              color={colores.rojo}
            />
          </View>

          <View >
            <Text style={styles.sucursalName}>Pingüino {sucursalInfo.sucursalId}</Text>
            <Text style={styles.sucursalDireccion}>{sucursalInfo.selectedSubBranch}</Text>
            <Text style={styles.sucursalTelefono}>{sucursalInfo.telefono}</Text>
          </View>

          <TouchableOpacity
            style={styles.cambiarSucursalButton}
            onPress={() => setModalVisible(true)}
          >
            <Text style={styles.cambiarSucursalText}>Cambiar</Text>
            <MaterialCommunityIcons
              name="chevron-right"
              size={16}
              color={colores.rojo}
            />
          </TouchableOpacity>
        </View>
      )}

      <View style={styles.infoContainer}>
        <View style={styles.infoItem}>
          <MaterialCommunityIcons name="information-outline" size={20} color={colores.rojo} />
          <Text style={styles.infoText}>Deberás presentar tu documento de identidad al retirar el pedido</Text>
        </View>

        <View style={styles.infoItem}>
          <MaterialCommunityIcons name="email-check-outline" size={20} color={colores.rojo} />
          <Text style={styles.infoText}>Recibirás un email cuando tu pedido esté listo para retirar</Text>
        </View>
      </View>

      {/* Modal para selección de sucursal */}
      <Modal
        visible={modalVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setModalVisible(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => setModalVisible(false)}
            >
              <MaterialCommunityIcons name="close" size={24} color={colores.textoPrincipal} />
            </TouchableOpacity>

            <Text style={styles.modalTitle}>Seleccionar Sucursal</Text>

            <SelecSuc
              onClose={() => setModalVisible(false)}
              onSelect={handleSucursalSelect}
            />
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    marginVertical: 10,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  titulo: {
    fontSize: 18,
    fontFamily: fuentes.semiBold,
    color: colores.textoPrincipal,
    marginLeft: 8,
  },
  sucursalName: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: fuentes.bold,
    color: colores.textoPrincipal,
  },
  sucursalIconContainer: {
    marginRight: 8,
  },
  subtitulo: {
    fontSize: 14,
    fontFamily: fuentes.regular,
    color: colores.textoSecundario,
    marginBottom: 16,
  },
  // Estilos para la sucursal seleccionada
  sucursalSeleccionadaContainer: {
    flexDirection: 'row',
    padding: 12,
    borderBottomWidth: 1,
    marginBottom: 12,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  sucursalTelefono: {
    fontSize: 14,
    fontFamily: fuentes.regular,
    color: colores.textoSecundario,
    marginBottom: 4,
  },
  cambiarSucursalButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  cambiarSucursalText: {
    fontSize: 14,
    fontFamily: fuentes.semiBold,
    color: colores.rojo,
    marginRight: 4,
  },
  // Estilos para el modal
  modalContainer: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: colores.blanco,
    borderRadius: 10,
    padding: 20,
    width: '90%',
    maxWidth: 600,
    maxHeight: '90%',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 10,
  },
  modalTitle: {
    fontSize: 22,
    fontFamily: fuentes.bold,
    color: colores.rojo,
    textAlign: 'center',
    marginBottom: 20,
  },
  sucursalItem: {
    flexDirection: 'row',
    padding: 12,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: colores.borde,
    marginBottom: 12,
  },
  sucursalSeleccionada: {
    borderColor: colores.rojo,
    backgroundColor: 'rgba(231, 29, 54, 0.05)',
  },
  radioContainer: {
    justifyContent: 'center',
    marginRight: 12,
  },
  radioOuter: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colores.grisClaro,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioOuterSelected: {
    borderColor: colores.rojo,
  },
  radioInner: {
    height: 10,
    width: 10,
    borderRadius: 5,
    backgroundColor: colores.rojo,
  },
  sucursalInfo: {
    flex: 1,
  },
  sucursalNombre: {
    fontSize: 16,
    fontFamily: fuentes.semiBold,
    color: colores.textoPrincipal,
    marginBottom: 4,
  },
  sucursalDireccion: {
    fontSize: 14,
    fontFamily: fuentes.regular,
    color: colores.textoSecundario,
    marginBottom: 8,
  },
  detallesContainer: {
    marginTop: 4,
  },
  detalle: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  detalleTexto: {
    fontSize: 12,
    fontFamily: fuentes.regular,
    color: colores.textoSecundario,
    marginLeft: 6,
  },
  infoContainer: {
    backgroundColor: 'rgba(0,0,0,0.02)',
    padding: 12,
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: colores.rojo,
    marginTop: 8,
  },
  infoItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  infoText: {
    fontSize: 14,
    fontFamily: fuentes.regular,
    color: colores.textoSecundario,
    marginLeft: 8,
    flex: 1,
  },
});

export default Retiro;
